const axios = require('axios');
const UtilitiesService = require('../services/utilities.es6');

const ENV = process.env;

export default class FlixelService {
  static getList(options) {
    const optionParams = options.params || {};
    const optionDisplayed = options.displayed || 24;
    const optionUrl = options.url || ENV.api + '/flixels/';
    const optionCache = options.cache || true;

    return new Promise(function (resolve, reject) {
      axios({
        method: 'GET',
        url: optionUrl,
        cache: optionCache,
        params: optionParams,
      })
        .then(function (data) {
          data.displayed = optionDisplayed;
          data.filter = {};
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  /**
   * Utility functions for flixels
   */

  static fixedSize(width, height, resize) {
    const scale = resize || 100;
    const scaledWidth = (width * scale) / 100;
    const scaledHeight = (height * scale) / 100;
    return {
      width: scaledWidth.toFixed(),
      height: scaledHeight.toFixed(),
    };
  }

  static responsive(width, height) {
    const aspect = width / height;
    const paddingBottom = {
      paddingBottom: (100 / aspect).toFixed(2),
    };
    return paddingBottom;
  }

  static createLink(mention) {
    const stripped = mention.replace('@', '');
    const link = '<a href="' + ENV.url + '/' + stripped + '">' + mention + '</a>';
    return link;
  }

  static formatCaptions(caption) {
    const mentions = caption.match(UtilitiesService.regAtMentions);
    _.each(mentions, function (mention) {
      const linkedMention = this.createLink(mention);
      caption = caption.replace(mention, linkedMention);
    });

    return caption;
  }

  /**
   * CRUD
   */

  static getOne(hash) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'GET',
        url: ENV.api + '/flixels/' + hash,
        cache: false,
      })
        .then(function (data) {
          data.height = data.height || '500';
          data.width = data.width || '500';
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  static update(formData, hash) {
    const accessToken = localStorage.getItem('access_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
    return new Promise(function (resolve, reject) {
      axios({
        method: 'PATCH',
        url: ENV.api + '/flixels/' + hash,
        headers: { 'Content-Type': undefined },
        data: formData,
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  static delete(hash) {
    const accessToken = localStorage.getItem('access_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
    return new Promise(function (resolve, reject) {
      axios({
        method: 'delete',
        url: ENV.api + '/flixels/' + hash,
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data);
        });
    });
  }

  /**
  * API Mapping
  */

  static apiMapping() {
    return {
      device: {
        0: {
          name: 'Cinemagraph for iOS',
          url: '/products/ios/cinemagraph-pro/',
        },
        1: {
          name: 'Cinemagraph Pro for iOS',
          url: '/products/ios/cinemagraph-pro/',
        },
        2: {
          name: 'Cinemagraph Pro for Mac',
          url: '/products/mac/cinemagraph-pro/',
        },
        3: {
          name: 'Cinemagraph+ for Mac',
          url: '/products/mac/cinemagraph-pro/',
        },
        7: {
          name: 'Cinemagraph Pro 2 for macOS',
          url: '/products/mac/cinemagraph-pro/',
        },
      },
    };
  }


  static returnPrivacy(statusId) {
    const status = {
      1: 'public',
      2: 'protected',
      3: 'private',
    };
    return status[statusId];
  }

  static returnStatus(statusId) {
    const status = {
      0: 'processing',
      1: 'complete',
      2: 'failed',
      3: 'created',
      4: 'retry',
    };
    return status[statusId];
  }
}



// WEBPACK FOOTER //
// ./src/services/flixel.es6.js